import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  infoItemText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  infoItemLabel: {
    fontSize: theme.fontSizes.smaller,
    color: theme.darkerGrey,
  },
  infoItemValue: {
    fontSize: theme.fontSizes.default,
    color: theme.black,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
}))

const InfoItem = (props) => {
  const { infoItem, className, classNameValue, classNameLabel, keepCase } = props
  const classes = useStyles()

  return (
    <div className={clsx(classes.container, className)}>
      <div className={clsx(classes.infoItemText, classes.infoItemLabel, classNameLabel)}>{keepCase ? infoItem.label : infoItem.label.toUpperCase()}</div>
      <div className={clsx(classes.infoItemText, classes.infoItemValue, classNameValue)}>{infoItem.value}</div>
    </div>
  )
}

InfoItem.propTypes = {
  infoItem: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  className: PropTypes.string,
  classNameValue: PropTypes.string,
  classNameLabel: PropTypes.string,
  keepCase: PropTypes.bool,
}

export default InfoItem
